<template>
  <div id="data-participants-list" class="w-full">
    <!-- modal -->
    <vs-popup
      width="300px"
      not-center
      v-model="showCheckinModal"
      class="modal"
      title="Confirmaçao de presença"
      :active.sync="showCheckinModal"
    >
      <!-- Checkin do participante -->
      <participant-checkin
        v-show="true"
        :showCheckinModal="showCheckinModal"
        :data="{ selectedParticipant, caravanist }"
        infinite-scroll-distance="0"
        infinite-scroll-throttle-delay="800"
        @presenceConfirmed="closeCheckinModalAndRefreshParticipantList"
        @photoUpdated="closeCheckinModalAndRefreshParticipantList"
      />
    </vs-popup>

    <p
      class="note"
      v-if="
        participants.length && participants[0].recording.participantsListClosed
      "
    >
      <strong>Obs:</strong> A lista de participantes abaixo já foi encerrada,
      não será possível realizar mais nenhuma ação nela.
    </p>
    <div class="no-records" v-if="participants.length < 1">
      <p>Nenhum participante encontrado</p>
    </div>

    <div id="recordings-participants-list" class="participants-list">
      <vs-card
        class="cardlist-data-recordings"
        :key="indextr"
        v-for="(item, indextr) in participants"
        :class="{
          'bg-card-success': item.status,
          'bg-card-pendent': !item.status,
        }"
      >
        <!-- <div
          v-if="waitingUpdate[item.participant.id] !== true && !item.status"
          class="trash-icon-div2"
        >
          <feather-icon
            @click="confirmParticipantRemotion(item.participant)"
            icon="Trash2Icon"
          />
        </div> -->
        <div class="content-container">
          <div class="col-photo-part">
            <div class="cardlist-logo" @click="openCheckinModal(item)">
              <!-- Avatar Col -->

              <div class="logo-container">
                <div class="img-container">
                  <img
                    v-if="item.participant.photo"
                    :src="item.participant.photo"
                    class="square"
                  />
                  <div v-else class="square-letter">
                    {{ item.participant.name | firstLetter }}
                  </div>
                  <div
                    :class="
                      isCheckinOk(item)
                        ? 'participant-checkin-ok'
                        : 'participant-checkin-no-ok'
                    "
                  >
                    <i
                      :class="
                        isCheckinOk(item) ? 'fa fa-thumbs-up' : 'fa fa-clock'
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-description-part" @click="openCheckinModal(item)">
            <div class="row-name">
              <span class="participant-name"
                >{{ item.participant.name }}
                {{ item.participant.surname }}</span
              >
            </div>
            <div class="cardlist-item-c">
              <div class="item-title">
                <i class="fa-regular fa-user"></i>
              </div>
              <div class="item-text">
                {{ item.participant.birthdate | calculateAge }} anos
              </div>
            </div>
            <div
              v-if="item.participant.email"
              class="cardlist-item-c"
              :class="{ 'hidden-item': !item.participant.email }"
            >
              <div class="item-title">
                <i class="fa-regular fa-envelope"></i>
              </div>
              <div class="item-text">{{ item.participant.email }}</div>
            </div>
            <div class="cardlist-item-c">
              <span class="item-title"
                ><i class="fa-brands fa-whatsapp"></i
              ></span>
              <div class="item-text">
                <span
                  v-if="item.participant.responsible"
                  @click="openWhatsApp(item?.participant?.responsible?.mobile)"
                >
                  {{ item?.participant?.responsible?.mobile | formatCelphone }}
                  <span class="name-chip">{{
                    item?.participant?.responsible?.name?.split(" ")[0]
                  }}</span>
                </span>
                <span v-else @click="openWhatsApp(item?.participant?.mobile)">
                  {{ item?.participant?.mobile | formatCelphone }}
                </span>
              </div>
            </div>
            <div class="cardlist-item-c" v-if="item.participant.specialNeed">
              <span class="item-title"><i class="fas fa-wheelchair"></i> </span>
              <span class="item-text">{{ item.participant.specialNeed }}</span>
            </div>
            <div class="cardlist-item-c" v-if="item.participant.specialNeed">
              <div v-if="item.recording.participantsListClosed === false">
                <vs-row vs-justify="flex-end">
                  <div v-if="isCheckinOk(item)"></div>

                  <vs-button
                    v-else-if="waitingUpdate[item.participant.id] === true"
                    @click="cancelParticipant(item.participant)"
                    color="warning"
                    type="filled"
                    icon="x"
                  >
                    Aguarde...
                  </vs-button>
                  <vs-button
                    style="padding: 0 8px; height: 30px"
                    @click="cancelParticipant(item.participant)"
                    v-else-if="item.status"
                    color="warning"
                    type="border"
                    icon="close"
                  >
                    Cancelar
                  </vs-button>

                  <vs-button
                    style="
                      display: none;
                      border: 1px solid #ddd;
                      color: #000;
                      background-color: #fff !important;
                      padding: 0px 20px;
                      align-items: center;
                      text-align: center;
                      height: 32px;
                    "
                    v-else-if="!item.status"
                    @click="openCheckinModal(item)"
                  >
                    <i class="fa fa-thumbs-up" style="margin-right: 4px"></i
                    >Confirmar
                  </vs-button>
                </vs-row>
              </div>
              <div v-else class="item-text">
                <span class="status-text">
                  {{ statusText(item.confirmedPresence) }}
                </span>
              </div>
            </div>

            <div
              v-if="waitingUpdate[item.participant.id] !== true && !item.status"
              class="trash-icon-div"
            >
              <feather-icon
                @click="confirmParticipantRemotion(item.participant)"
                icon="Trash2Icon"
              />
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import ParticipantCheckin from "./ParticipantCheckin.vue";
import { sendSentryMessage } from "@/utils/sentry";

export default {
  components: {
    ParticipantCheckin,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      selectedParticipant: null,
      isSearching: false,
      searchField: "name",
      searchTerms: "",
      waitingUpdate: {},
      showCheckinModal: false,
      showContactsModal: true,
    };
  },

  computed: {
    showMobile() {},
    participants() {
      return this.data.participants || [];
    },
    caravanist() {
      return this.data.caravanist || null;
    },
  },
  methods: {
    // esse método é chamado de dentro do modal. Veja o modal acima
    closeCheckinModalAndRefreshParticipantList() {
      this.showCheckinModal = false;
      // Isso vai chamar o método abaixo do arquivo pai
      // o Arquivo pai é a Tab "RecordingDetailsTabPublic.vue"
      console.log("closeCheckinModalAndRefreshParticipantList");
      this.$emit("refreshItems");
    },

    isCheckinOk: (item) => {
      return !!item.status;
    },
    alertNotAllowed(message) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Lista encerrada`,
        text: message,
        acceptText: "OK",
      });
    },
    openWhatsApp(phoneNumber) {
      // Construct the WhatsApp URL
      const whatsappURL = `https://wa.me/${phoneNumber}`;

      // Open the WhatsApp URL
      window.open(whatsappURL, "_blank");

      sendSentryMessage("Caravanista abriu o whatsapp ✆✆✆", "info", "wpp", {
        phoneNumber,
      });
    },

    openCheckinModal(item) {
      this.selectedParticipant = item;
      this.showCheckinModal = true;
    },
    statusText(confirmedPresence) {
      if (confirmedPresence === true) return " Participante presente";
      return " Aguardando confirmação de presença";
    },
    alertClosedList() {
      this.alertNotAllowed(
        `Você não pode executar essa ação pois a lista foi encerrada pelo Administrador.`
      );
    },
    confirmParticipantRemotion(item) {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      const { name, surname } = item;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Remoção de Participante`,
        text: `Por favor, confirme a remoção do participante "${
          name + " " + surname
        }".`,
        acceptText: "Remover",
        cancelText: "Cancelar",
        accept: () => {
          this.removeParticipant(item);
          this.removeInviteWelcome(item);
        },
      });
    },
    refreshParticipants() {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      this.$store
        .dispatch("recording/fetchParticipants", {
          recordingId: this.$route.params.id,
          limit: this.data.itemsPerPage,
          offset: (this.data.page - 1) * this.data.itemsPerPage,
        })
        .finally(() => {});
    },
    searchParticipants() {
      this.$store
        .dispatch("recording/searchParticipants", {
          field: this.searchField,
          terms: this.searchTerms,
          limit: this.data.itemsPerPage,
          offset: (this.data.page - 1) * this.data.itemsPerPage,
        })
        .finally(() => {});
    },
    setWaiting(id, status) {
      this.waitingUpdate = Object.assign(
        { ...this.waitingUpdate },
        {
          [id]: status || false,
        }
      );
    },
    confirmParticipant(item) {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      this.setWaiting(item.id, true);
      this.$store
        .dispatch("recording/confirmParticipant", {
          recordingId: this.$route.params.id,
          participantId: item.id,
        })
        .finally(() => {
          this.toastMsg(`Você confirmou a participação de "${item.name}"!`);
          this.setWaiting(item.id, false);
        });
    },
    cancelParticipant(item) {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      this.setWaiting(item.id, true);
      this.$store
        .dispatch("recording/cancelParticipant", {
          recordingId: this.$route.params.id,
          participantId: item.id,
        })
        .finally(() => {
          this.toastMsg(
            `Você deixou a participação de "${item.name}" como pendente.`
          );
          this.setWaiting(item.id, false);
        });
    },
    removeParticipant(item) {
      this.setWaiting(item.id, true);
      this.$store
        .dispatch("recording/removeParticipant", {
          recordingId: this.$route.params.id,
          participantId: item.id,
        })
        .finally(() => {
          this.$emit("refreshItems");
          this.setWaiting(item.id, false);
          this.toastMsg(
            `Você removeu "${item.name}" da lista de participantes.`
          );
        });
    },
    removeInviteWelcome(item) {
      if (item.invitees) {
        item.invitees.map((item) => {
          this.$store
            .dispatch("recording/removeInviteWelcome", {
              inviteeId: item.id,
              recording: 1,
            })
            .finally(() => {});
        });
      }
    },
    toastMsg(msg, success = true) {
      this.$vs.notify({
        text: msg,
        color: success ? "success" : "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        time: 10000,
        position: "bottom-left",
      });
    },
  },
  filters: {
    formatDate: function (date) {
      if (!date) return;
      return date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
    },
    calculateAge(date) {
      if (!date) return "";
      var ageDifMs = Date.now() - new Date(date).getTime();
      var ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    formatGender: (value) => {
      if (!value) return "";
      switch (value) {
        case "male":
          return "Masc...";
        case "female":
        case "feminine":
          return "Femin..";
        default:
          return "Outros";
      }
    },
    firstLetter: (value) => {
      if (!value) return "";
      return String(value[0] || " ").toUpperCase();
    },
    formatCelphone: (value) => {
      if (!value) return "";
      return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.participant-checkin-ok {
  background: #62df73;
  color: #fff;
  text-align: center;
  width: 30px;
  border-radius: 12px;
  margin-top: 2px;
  position: bottom;
  margin-left: calc(50% - 15px);
  margin-bottom: -10px;
}
.participant-checkin-no-ok {
  background: rgb(255, 106, 0) !important;
  color: rgb(65, 40, 2);
  text-align: center;
  border-radius: 12px;
  width: 30px;
  margin-top: 2px;
  position: bottom;
  margin-left: calc(50% - 15px);
  margin-bottom: -10px;
}
.square-letter {
  width: 80px;
  height: 90px;
  background: #ddd;
  border-radius: 12px;
  font-size: 40px;
  font-weight: bolder;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbb;
}
.img-container img {
  border-radius: 6px !important;
  width: 80px !important;
  height: 90px !important;
  object-fit: cover;
  background-color: #ddd;
}
.content-container {
  padding-top: 2px;
  display: flex;
  min-height: 96px;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}
.col-photo-part {
  margin-left: -6px;
  margin-top: -6px;
  width: 80px;
  height: 80px;
  display: flex;
}
.col-description-part {
  display: flex;
  margin-left: 10px;
  flex-direction: column;
  width: calc(100% - 70px);
}

.row-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  width: 100%;
}
.participant-name {
  font-weight: bold;
  color: #000;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.trash-icon-div {
  position: absolute;
  z-index: 1;
  right: 10px;
  margin-top: 65px;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #666;
  background-color: rgb(255, 232, 232);
  width: 30px;
  height: 30px;
  display: flex;
  border-radius: 5px;
}
.cardlist-item-c {
  margin-top: 2px;
  font-size: 13px;
  display: flex;
  justify-content: flex-end;
  height: 20px;
  width: 100%;
  flex-direction: row;
}
.item-title {
  display: flex;
  width: 24px;
  color: #aaa;
  align-items: center;
}
.item-text {
  display: flex;
  width: 100%;
  flex: 1;
}
.name-chip {
  background: #eee;
  font-size: 10px;
  border-radius: 10px;
  padding: 2px 10px;
}

#data-recordings-list-view {
  .cardlist-row-name {
    .item-title {
      margin: -4px 0 5px;
    }
  }
}
.note {
  font-size: 12px;
}

.status-text {
  padding-left: 4px;
}
</style>
